var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "tabindex": "0",
      "role": 'banner ' + ((_vm.status == 'warning' || _vm.status == 'critical') ? 'alert' : ''),
      "aria-describedby": _vm.realId + 'Content',
      "aria-labelledby": _vm.realId + 'Heading'
    }
  }, [(_vm.hasOnDismissHandler) ? _c('div', {
    staticClass: "Polaris-Banner__Dismiss"
  }, [_c('polaris-button', {
    attrs: {
      "plain": "",
      "icon-only": "",
      "accessibility-label": "Dimiss notification",
      "icon": _vm.dismissIcon
    },
    on: {
      "click": _vm.onDismiss
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "Polaris-Banner__Ribbon"
  }, [_c('polaris-icon', {
    attrs: {
      "source": _vm.iconSource,
      "color": _vm.iconColor,
      "backdrop": ""
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.title) ? _c('div', {
    staticClass: "Polaris-Banner__Heading",
    attrs: {
      "id": _vm.realId + 'Heading'
    }
  }, [_c('polaris-heading', {
    attrs: {
      "tag": "p"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.$slots.default || _vm.action || _vm.secondaryAction || _vm.children) ? _c('div', {
    staticClass: "Polaris-Banner__Content",
    attrs: {
      "id": "realId+'Content'"
    }
  }, [_vm._t("default", [(_vm.children) ? _c('div', [_vm._v(_vm._s(_vm.children))]) : _vm._e()]), _vm._v(" "), (_vm.action) ? _c('div', {
    staticClass: "Polaris-Banner__Actions"
  }, [_c('polaris-button-group', [_c('polaris-button', {
    attrs: {
      "outline": "",
      "url": _vm.action.url,
      "destructive": _vm.action.destructive,
      "disabled": _vm.action.disabled,
      "accessibility-label": _vm.action.accessibilityLabel,
      "icon": _vm.action.label
    },
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.action)
      }
    },
    slot: "1"
  }, [_vm._v("\n                        " + _vm._s(_vm.action.content) + "\n                    ")]), _vm._v(" "), (_vm.secondaryAction) ? _c('div', {
    staticClass: "Polaris-Banner__SecondaryAction",
    on: {
      "click": function($event) {
        _vm.handleAction(_vm.secondaryAction, true)
      }
    },
    slot: "2"
  }, [_c('span', {
    staticClass: "Polaris-Banner__Text"
  }, [_vm._v("\n                            " + _vm._s(_vm.secondaryAction.content) + "\n                        ")])]) : _vm._e()], 1)], 1) : _vm._e()], 2) : _vm._e()])])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ac00826a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac00826a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisBanner.vue
// module id = 181
// module chunks = 0